import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Footer from "../../Components/Footer/footer";
import ButtonWithSVG from "../../Components/layouts/button_with_svg";
import StepRoutes from "../../Routes/steps_routes";
import performRequest from "../../api/request";
import { Toast } from "../../CustomComponent/toast";
import Pagination from "../../Components/layouts/pagination";
import getFilteredURL from "../../Components/Functions/filters.getUrl";
import DynamicFilterInput from "../../Components/layouts/filter.inpit";
import DynamicFilterSelect from "../../Components/layouts/filter.select";
import LoadingPage from "../../Components/layouts/loading";
import SiteInspectionTable from "./Site Inspection/site_inspection_table";
import { CustomErrorResponse } from "../../CustomComponent/custom_error_response";
import { FcPanorama } from "react-icons/fc";
import CustomViedoCard from "../../CustomComponent/custom_viedo_card";
import { loginSuccess } from "../../redux/user/loginReducer";
import { useSearchParams, useNavigate, useLocation } from "react-router-dom";

const ClientSiteInspection = () => {
  const user = useSelector((store) => store.login.user);
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [refresh, setRefresh] = useState(false);
  const [leadOwner, setLeadOwner] = useState([]);
  const [filters, setFilters] = useState({
    startdate: "",
    enddate: "",
    name: "",
    leadowner: "",
    project: "",
  });
  const [page, setPage] = useState(1);
  const [showPage, setShowPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [data, setData] = useState([]);
  const store = useSelector((store) => store.login.user);
  const storeLog = useSelector((store) => store.login);
  const [projects, setProjects] = useState([]);
  const [siteInspectionCount, setSiteInspectionCount] = useState(0);
  const [themeSet, setThemeSet] = useState("");
  const [searchParams] = useSearchParams();
  const theme = searchParams.get("theme");
  const [quotations, setQuotations] = useState([]);

  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const pageFromUrl = parseInt(params.get("page")) || 1;
    setPage(pageFromUrl);
  }, []);

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    params.set("page", page);
    navigate({ search: params.toString() }, { replace: true });
  }, [page]);

  useEffect(() => {
    setThemeSet(theme);
  }, [theme]);

  useEffect(() => {
    dispatch(
      loginSuccess({
        ...user,
        step: 0,
        submissionId: "",
      })
    );

    performRequest("GET", "/clientProject/getCpName/")
      .then((res) => setProjects(res.data.clientProjectsData))
      .catch((err) => CustomErrorResponse(err));
  }, []);

  useEffect(() => {
    setLoading(true);
    performRequest(
      "GET",
      getFilteredURL("/siteInspection/getSiteInspection", page, filters)
    )
      .then((res) => {
        if (res.status === 200) {
          setData(res.data);
          setSiteInspectionCount(res.data?.siteInspectionCount);
          setTotalPages(Math.ceil(res.data?.siteInspectionCount / 50));
        } else {
          Toast("error", "Error while getting Leads!");
        }
      })
      .catch((err) => {
        CustomErrorResponse(err);
      })
      .finally(() => setLoading(false));
  }, [refresh, page]);

  useEffect(() => {
    performRequest("GET", "/leads/getAllLeadsOwners")
      .then((res) => setLeadOwner(res.data))
      .catch((err) => CustomErrorResponse(err));
  }, []);

  if (loading) {
    return <LoadingPage />;
  }
  return (
    <div className="page">
      <div className="page-wrapper">
        <div className="container-xxl">
          <div className="page-header d-print-none">
            <div className="container-xl">
              <div className="row g-2 align-items-center">
                <div className="col mb-0">
                  <h2 className="page-title">
                    <FcPanorama className="fs-2 me-1" />
                    Site Inspection
                  </h2>
                  <h4 className="text-muted mb-0">
                    <StepRoutes />
                  </h4>
                </div>
                {user.Role !== process.env.REACT_APP_ROLE_D_CLIENT &&
                  user.Role !== process.env.REACT_APP_ROLE_CLIENT && (
                    <div className="col-auto ms-auto d-print-none">
                      <div className="d-flex d-none d-sm-block">
                        <ButtonWithSVG
                          href={"/client-site-inspection/new"}
                          buttonText="New Site Inspection"
                          svg={
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              className="icon"
                              width="24"
                              height="24"
                              viewBox="0 0 24 24"
                              strokeWidth="2"
                              stroke="currentColor"
                              fill="none"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            >
                              <path
                                stroke="none"
                                d="M0 0h24v24H0z"
                                fill="none"
                              />
                              <path d="M12 5l0 14" />
                              <path d="M5 12l14 0" />
                            </svg>
                          }
                        />
                      </div>
                    </div>
                  )}

                {(user.Role === process.env.REACT_APP_ROLE_D_CLIENT ||
                  user.Role === process.env.REACT_APP_ROLE_CLIENT) && (
                  <div className="col-auto ms-auto d-print-none">
                    <div className="d-flex d-none d-sm-block">
                      <ButtonWithSVG
                        href={"/client-site-inspection/new"}
                        buttonText="Create Site Inspection"
                        disabled={
                          !!siteInspectionCount && siteInspectionCount > 10
                        }
                        svg={
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            className="icon"
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            strokeWidth="2"
                            stroke="currentColor"
                            fill="none"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          >
                            <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                            <path d="M12 5l0 14" />
                            <path d="M5 12l14 0" />
                          </svg>
                        }
                      />
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>

          <div className="page-body">
            <div className="container-xl">
              <div className="row">
                <div className="col-md-3 col-sm-12">
                  <div className="card p-2">
                    <div
                      id="faq-1"
                      className="accordion"
                      role="tablist"
                      aria-multiselectable="true"
                    >
                      <div>
                        <div
                          className={`accordion-header m-0 ${
                            themeSet === "dark" ? "text-light" : ""
                          }`}
                          role="tab"
                        >
                          <button
                            className="accordion-button fs-3 d-md-none p-0"
                            data-bs-toggle="collapse"
                            data-bs-target="#faq-1-1"
                          >
                            <h3 className="m-1">Filter result</h3>
                          </button>
                        </div>

                        <div
                          id="faq-1-1"
                          className="accordion-collapse collapse d-md-none"
                          role="tabpanel"
                          data-bs-parent="#faq-1"
                        >
                          <div className="accordion-body pt-0 ">
                            <div className="row">
                              <div className="col-12">
                                <DynamicFilterInput
                                  label="Start Date:"
                                  value={filters.startdate}
                                  onChange={(e) =>
                                    setFilters({
                                      ...filters,
                                      startdate: e.target.value,
                                    })
                                  }
                                  type="date"
                                />
                              </div>
                              <div className="col-12">
                                <DynamicFilterInput
                                  label="End Date:"
                                  value={filters.enddate}
                                  onChange={(e) =>
                                    setFilters({
                                      ...filters,
                                      enddate: e.target.value,
                                    })
                                  }
                                  type="date"
                                />
                              </div>
                              <div className="col-12">
                                <DynamicFilterInput
                                  label="Search name:"
                                  value={filters.name}
                                  onChange={(e) =>
                                    setFilters({
                                      ...filters,
                                      name: e.target.value,
                                    })
                                  }
                                  placeholder="search name..."
                                />
                              </div>
                              <div className="col-12">
                                <DynamicFilterSelect
                                  label="Search lead owner:"
                                  onChange={(e) =>
                                    setFilters({
                                      ...filters,
                                      leadowner: e.target.value,
                                    })
                                  }
                                  value={filters.leadowner}
                                >
                                  <option value="">select all</option>
                                  {leadOwner &&
                                    leadOwner?.map((lead, index) => {
                                      return (
                                        <option
                                          key={index}
                                          value={lead?.userName}
                                        >
                                          {lead?.userName}
                                        </option>
                                      );
                                    })}
                                </DynamicFilterSelect>
                              </div>
                              {(store.Role ===
                                process.env.REACT_APP_ROLE_ADMIN_S ||
                                store.Role ===
                                  process.env.REACT_APP_ROLE_ADMIN) && (
                                <div className="col-12">
                                  <DynamicFilterSelect
                                    label="Search project:"
                                    onChange={(e) =>
                                      setFilters({
                                        ...filters,
                                        project: e.target.value,
                                      })
                                    }
                                    value={filters.project}
                                  >
                                    <option value="">select all</option>

                                    {projects &&
                                      projects?.map((state, index) => (
                                        <option
                                          key={index}
                                          value={state?.clientName}
                                        >
                                          {state?.clientName}
                                        </option>
                                      ))}
                                  </DynamicFilterSelect>
                                </div>
                              )}

                              <div className="col-12">
                                <div className="row mt-2">
                                  <div className="col-6">
                                    <button
                                      onClick={() => setRefresh(!refresh)}
                                      className="btn btn-success w-100"
                                    >
                                      Apply Filter
                                    </button>
                                  </div>
                                  <div className="col-6">
                                    <button
                                      onClick={() => {
                                        setFilters({
                                          startdate: "",
                                          enddate: "",
                                          name: "",
                                          leadowner: "",
                                          project: "",
                                        });
                                        setRefresh(!refresh);
                                      }}
                                      className="btn btn-secondary w-100"
                                    >
                                      Reset Filter
                                    </button>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div
                          className={`accordion-body d-none d-md-block ${
                            themeSet === "dark" ? "text-light" : ""
                          } `}
                        >
                          <div className="row">
                            <h3>Filter result</h3>
                            <div className="col-12">
                              <DynamicFilterInput
                                label="Start Date:"
                                value={filters.startdate}
                                onChange={(e) =>
                                  setFilters({
                                    ...filters,
                                    startdate: e.target.value,
                                  })
                                }
                                type="date"
                              />
                            </div>
                            <div className="col-12">
                              <DynamicFilterInput
                                label="End Date:"
                                value={filters.enddate}
                                onChange={(e) =>
                                  setFilters({
                                    ...filters,
                                    enddate: e.target.value,
                                  })
                                }
                                type="date"
                              />
                            </div>
                            <div className="col-12">
                              <DynamicFilterInput
                                label="Search name:"
                                value={filters.name}
                                onChange={(e) =>
                                  setFilters({
                                    ...filters,
                                    name: e.target.value,
                                  })
                                }
                                placeholder="search name..."
                              />
                            </div>
                            <div className="col-12">
                              <DynamicFilterSelect
                                label="Search lead owner:"
                                onChange={(e) =>
                                  setFilters({
                                    ...filters,
                                    leadowner: e.target.value,
                                  })
                                }
                                value={filters.leadowner}
                              >
                                <option value="">select all</option>
                                {leadOwner &&
                                  leadOwner?.map((lead, index) => {
                                    return (
                                      <option
                                        key={index}
                                        value={lead?.userName}
                                      >
                                        {lead?.userName}
                                      </option>
                                    );
                                  })}
                              </DynamicFilterSelect>
                            </div>
                            {(store.Role ===
                              process.env.REACT_APP_ROLE_ADMIN_S ||
                              store.Role ===
                                process.env.REACT_APP_ROLE_ADMIN) && (
                              <div className="col-12">
                                <DynamicFilterSelect
                                  label="Search project:"
                                  onChange={(e) =>
                                    setFilters({
                                      ...filters,
                                      project: e.target.value,
                                    })
                                  }
                                  value={filters.project}
                                >
                                  <option value="">select all</option>

                                  {projects &&
                                    projects?.map((state, index) => (
                                      <option
                                        key={index}
                                        value={state?.clientName}
                                      >
                                        {state?.clientName}
                                      </option>
                                    ))}
                                </DynamicFilterSelect>
                              </div>
                            )}

                            <div className="col-12">
                              <div className="row mt-2">
                                <div className="col-6">
                                  <button
                                    onClick={() => setRefresh(!refresh)}
                                    className="btn btn-success w-100"
                                  >
                                    Apply Filter
                                  </button>
                                </div>
                                <div className="col-6">
                                  <button
                                    onClick={() => {
                                      setFilters({
                                        startdate: "",
                                        enddate: "",
                                        name: "",
                                        leadowner: "",
                                        project: "",
                                      });
                                      setPage(1);
                                      setRefresh(!refresh);
                                    }}
                                    className="btn btn-secondary w-100"
                                  >
                                    Reset Filter
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="d-none d-lg-block d-md-block">
                    <CustomViedoCard
                      viedoLink={"https://www.youtube.com/embed/LP8tXH6c5Kc"}
                      id={"model-viedo"}
                      name={"site inspection"}
                    ></CustomViedoCard>
                  </div>
                  <div className="card mt-2">
                    <div className="card-body p-0">
                      <img
                        className="d-none d-sm-block"
                        src="https://res.cloudinary.com/bsgfcooa/image/upload/v1753079171/4_vf4fmv_ulvb8g_llltkk.jpg"
                        alt="plantvisittoday"
                      />
                    </div>
                  </div>
                </div>

                <div className="col-md-9 col-sm-12 py-2">
                  <div className="card">
                    {data && (
                      <SiteInspectionTable
                        SI={data?.siteInspectionData}
                        currentPage={page}
                        itemsPerPage={50}
                      />
                    )}

                    {user.Role !== process.env.REACT_APP_ROLE_D_CLIENT &&
                      user.Role !== process.env.REACT_APP_ROLE_CLIENT && (
                        <div className="btn-list justify-content-center">
                          <div className="d-lg-none d-md-none mt-3 mb-3">
                            <ButtonWithSVG
                              href={"/client-site-inspection/new"}
                              buttonText="New Site Inspection"
                              svg={
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  className="icon"
                                  width="24"
                                  height="24"
                                  viewBox="0 0 24 24"
                                  strokeWidth="2"
                                  stroke="currentColor"
                                  fill="none"
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                >
                                  <path
                                    stroke="none"
                                    d="M0 0h24v24H0z"
                                    fill="none"
                                  />
                                  <path d="M12 5l0 14" />
                                  <path d="M5 12l14 0" />
                                </svg>
                              }
                            />
                          </div>
                        </div>
                      )}

                    {(user.Role == process.env.REACT_APP_ROLE_D_CLIENT ||
                      user.Role == process.env.REACT_APP_ROLE_CLIENT) && (
                      <div className="btn-list justify-content-center">
                        <div className="d-lg-none d-md-none mt-3 mb-3">
                          <ButtonWithSVG
                            href={"/client-site-inspection/new"}
                            buttonText="Create  Site Inspection"
                            disabled={
                              !!siteInspectionCount && siteInspectionCount > 10
                            }
                            svg={
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                className="icon"
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                strokeWidth="2"
                                stroke="currentColor"
                                fill="none"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              >
                                <path
                                  stroke="none"
                                  d="M0 0h24v24H0z"
                                  fill="none"
                                />
                                <path d="M12 5l0 14" />
                                <path d="M5 12l14 0" />
                              </svg>
                            }
                          />
                        </div>
                      </div>
                    )}

                    <Pagination
                      page={page}
                      setPage={setPage}
                      totalPages={totalPages}
                      pageDatalength={data?.siteInspectionData?.length}
                      showPage={showPage}
                      setShowPage={setShowPage}
                    />
                  </div>

                  {/* dfdf */}
                  <div className="card mt-2 border-0">
                    <div className="card-body p-0">
                      <img
                        className="d-block d-sm-none"
                        src="https://res.cloudinary.com/bsgfcooa/image/upload/v1753079171/4_vf4fmv_ulvb8g_llltkk.jpg"
                        alt="plantvisittoday"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="d-block d-lg-none d-md-none ms-2 me-2">
            <CustomViedoCard
              viedoLink={"https://www.youtube.com/embed/LP8tXH6c5Kc"}
              id={"model-viedo2"}
              name={"site inspection"}
            ></CustomViedoCard>
          </div>
        </div>

        <Footer />
      </div>
    </div>
  );
};

export default ClientSiteInspection;
